import { render, staticRenderFns } from "./Tablo.vue?vue&type=template&id=5102e016&scoped=true&"
import script from "./Tablo.vue?vue&type=script&lang=js&"
export * from "./Tablo.vue?vue&type=script&lang=js&"
import style0 from "./Tablo.vue?vue&type=style&index=0&id=5102e016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102e016",
  null
  
)

export default component.exports